var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHmIconBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lucide Icons / book-open-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23 13.4167C23 11.3833 22.1923 9.43329 20.7545 7.99551C19.3167 6.55774 17.3667 5.75 15.3333 5.75H3.83333V34.5H17.25C18.775 34.5 20.2375 35.1058 21.3159 36.1841C22.3942 37.2625 23 38.725 23 40.25M23 13.4167V40.25M23 13.4167C23 11.3833 23.8077 9.43329 25.2455 7.99551C26.6833 6.55774 28.6333 5.75 30.6667 5.75H42.1667V34.5H28.75C27.225 34.5 25.7625 35.1058 24.6841 36.1841C23.6058 37.2625 23 38.725 23 40.25M11.5 15.3333H15.3333M11.5 23H15.3333M30.6667 15.3333H34.5M30.6667 23H34.5",
    stroke: "#FA9846",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHmIconBook);
export default __webpack_public_path__ + "static/media/hmIconBook.2f4b654a9b7c795bded9791da8cdc98c.svg";
export { ForwardRef as ReactComponent };